import { render, staticRenderFns } from "./videoSet.vue?vue&type=template&id=0210a9a1&scoped=true&"
import script from "./videoSet.vue?vue&type=script&lang=js&"
export * from "./videoSet.vue?vue&type=script&lang=js&"
import style0 from "./videoSet.vue?vue&type=style&index=0&id=0210a9a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210a9a1",
  null
  
)

export default component.exports